import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=5adb510b&scoped=true&"
import script from "./DueDate.vue?vue&type=script&lang=js&"
export * from "./DueDate.vue?vue&type=script&lang=js&"
import style0 from "./DueDate.vue?vue&type=style&index=0&id=5adb510b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb510b",
  null
  
)

export default component.exports